<template>
  <div class="wistia-wrapper">
    <div
        :id="playerId"
        :class="`wistia_embed wistia_async_${mediaId}`"
        style="height:360px;width:100%"
    >
      &nbsp;
    </div>
  </div>
</template>

<script>
export default {
  name: 'MyWistiaPlayer',
  props: {
    mediaId: {
      type: String,
      required: true
    }
  },
  computed: {
    playerId() {
      return `wistia_player_${this.mediaId}`
    }
  },
  mounted() {
    if (!document.querySelector('script[src="https://fast.wistia.com/assets/external/E-v1.js"]')) {
      const script = document.createElement('script')
      script.src = 'https://fast.wistia.com/assets/external/E-v1.js'
      script.async = true
      document.body.appendChild(script)
    }
  }
}
</script>

<style scoped>
.wistia-wrapper {
  width: 100%;
}
</style>
